/**
 * Centralized external destinations so a single edit updates every
 * surface across the site. Currently used for the Amazon Kindle
 * listing of Authentic Momentum, which now serves as the canonical
 * point of sale for the book. The Stripe-powered $19.99 PDF flow
 * remains wired up in the backend in case it is ever re-enabled.
 */
export const AMAZON_BOOK_URL =
  "https://www.amazon.com/Authentic-Momentum-Struggle-Universal-Frequency-ebook/dp/B0H5X46JLH/";

// Props bundle for any anchor that opens the Amazon listing. Keeps
// every CTA consistent (new tab, no referrer leakage, accessible
// label) so we never re-invent these attributes per component.
export const amazonBookLinkProps = {
  href: AMAZON_BOOK_URL,
  target: "_blank",
  rel: "noopener noreferrer",
  "aria-label": "Buy Authentic Momentum on Amazon (opens in a new tab)",
};
